export default __webpack_public_path__ + "static/onefam-homepage-97072550df455e39bde9a4d1d85d827e.jpg";